import Header from "../../components/shared/Header";
import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";
import Hero from "./Hero";
import OurProducts from "./OurProducts";
import Roadmap from "./Roadmap";
import Footer from "../../components/shared/Footer";

export default function Home() {
	return (
		<>
			<Header />

			<Hero />

			<AboutUs />

			<OurProducts />

			<Roadmap />

			<ContactUs />

			<Footer />
		</>
	);
}
